/* import __COLOCATED_TEMPLATE__ from './submenu-sections-section-title-arrow.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';

export default class SubmenuSectionsSectionTitleArrow extends Component {
  get isOpenIsDefined() {
    return this.args.isOpen !== undefined;
  }
}
